import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useContext } from 'react';

import { white } from '@styles/colors';
import { medium } from '@styles/fontWeights';
import { socialShareOptions } from '@features/boostMyJobs/components/PostHiringLinkModal/constants';
import { Employer } from '../types';
import CloseIcon from '@mui/icons-material/Close';
import { ShareIcon } from '../../../vectors/index';

type AdminPostHiringLinkModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  item: Employer
};

const getButtonStyles = (mainColor: string) => ({
  boxShadow: 'none',
  backgroundColor: mainColor,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: mainColor,
  fontWeight: medium,
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: mainColor,
    color: mainColor,
    svg: {
      color: mainColor,
    },
  },
});

const AdminPostHiringLinkModal: FC<AdminPostHiringLinkModalProps> = ({
  isOpen,
  handleClose,
  item,
}) => {

  const handleShare = (url: string) => {
    const companyUrl = encodeURIComponent(
      `${import.meta.env.VITE_MARKETING_SITE_URL}${item.company ? item.company.s_slug : item.enterprise ? item.enterprise.s_slug : ""}`,
    );
    window.open(`${url}${companyUrl}`, '_blank');
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <ShareIcon />
        <br />
        <Typography variant="h4">Post Your Hiring Link</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ marginBottom: 2 }}>
          {socialShareOptions.map(({ title, url, color, Icon }) => (
            <Button
              key={title}
              variant="contained"
              sx={getButtonStyles(color)}
              startIcon={<Icon sx={{ color: white }} />}
              onClick={() => handleShare(url)}
            >
              {title}
            </Button>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AdminPostHiringLinkModal;
